import { Card } from '@odmonorepo/core-components';
import { Link } from '@tanstack/react-router';

export function CredentialCard() {
  return (
    <Card>
      <div>
        <div className="fs-6 fw-bold mb-4">Privacy and Sign In</div>
        <Link className="fw-semibold" to="/password">
          Reset my password
        </Link>
      </div>
    </Card>
  );
}

export default CredentialCard;
